module.exports = __webpack_public_path__ + "static/media/扫码成功@3x.dd25b.png";